import { memo } from "react";

interface Props {
  isOn: boolean;
  handleToggle: () => void;
  size?: "sm" | "md" | "lg";
  loading?: boolean;
  disabled?: boolean;
}

const Toggle = ({
  isOn,
  handleToggle,
  size = "md",
  loading,
  disabled,
}: Props) => {
  const getToggleClassName = () => {
    let baseText = `toggle ${size}`;
    if (isOn) {
      baseText += " active";
    }
    if (loading) {
      baseText += " loading";
    }
    if (disabled) {
      baseText += " disabled";
    }

    return baseText;
  };

  return (
    <div
      className={getToggleClassName()}
      onClick={disabled ? undefined : handleToggle}
    >
      <div className="toggle-thumb" />
    </div>
  );
};

export default memo(Toggle);
